export var DirectionEnum;

!function(DirectionEnum) {
    DirectionEnum.Default = "default", DirectionEnum.Reverse = "reverse";
}(DirectionEnum || (DirectionEnum = {}));
//# sourceMappingURL=direction.js.map
